// @flow
import React from 'react'
import './styles.scss'

const isMobile = window.innerWidth < 600

export class Scenario extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <div className='scenario'>
        <img className='illustration' src={this.props.illustration} />
        <div className='top'>
          <h4>{this.props.subtitle}</h4>
          <h3>{this.props.title}</h3>
        </div>
        <div className='emissions'>
          <div className='cat heating'>
            <div>
              <img
                className='ui image fluid'
                src={require('../../images/icon-heating.svg')}
              />
            </div>
            <div className='txt'>{this.props.heizung}</div>
          </div>
          <div className='cat car'>
            <div>
              <img
                className='ui image fluid'
                src={require('../../images/icon-car.svg')}
              />
            </div>
            <div className='txt'>{this.props.auto}</div>
          </div>
          <div className='cat flying'>
            <div>
              <img
                className='ui image fluid'
                src={require('../../images/icon-flying.svg')}
              />
            </div>
            <div className='txt'>{this.props.fliegen}</div>
          </div>
        </div>
        <div className='balance'>{this.props.children}</div>
      </div>
    )
  }
}
